import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.BASE_URL || 'https://backend.staging.geografiademercado.com',
  // baseURL: process.env.BASE_URL || 'http://127.0.0.1:8000',
});

export default api;
